module.exports = __webpack_public_path__ + "Server-Default.AzureWebApp.a43f8433d1b75688eb804f89bf4e5f42.hashedasset.svg";